import { useCallback, useEffect, useState } from "react";

import { observer } from "mobx-react-lite";

import { useGlobal } from "../../contexts/globalContext";
import { useJanusContext } from "../../contexts/janus/JanusContext";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { useOSIcons } from "../../hooks/useOSIcons";
import { selectScreen } from "../../pages/fullscreen/screen-list";
import { Video } from "../video-element";

export const TileViewScreenItem = observer(({ updateFullScreenUI }) => {
  const { SCREEN_STATE, MEDIA_TRACKS, SET_SCREEN_STATE } = useGlobal();
  const { meeting } = useMeetingDetailsStore();
  const { oldScreensArray } = useJanusContext();

  const [screensWithTracks, setScreensWithTracks] = useState([]);

  const { osIcons, fetchOsIcons } = useOSIcons(meeting.screens);

  const collectScreens = useCallback(() => {
    if (Object.keys(MEDIA_TRACKS).length) {
      const screens = oldScreensArray.filter((screen) => screen.id > 0);

      const combinedScreenData = screens.map((screenItem) => {
        const correctStreamId = screenItem.id > 100 && screenItem.id < 200 ? screenItem.id : screenItem.id - 100;

        const track = {};
        const trackEntry = Object.entries(MEDIA_TRACKS).find(([key]) => key.includes(correctStreamId + 1));
        if (trackEntry) {
          const [, trackValue] = trackEntry;
          track.track = trackValue;
        }
        console.log({ ...screenItem, ...track });

        return { ...screenItem, ...track };
      });
      setScreensWithTracks(combinedScreenData);
    }
  }, [MEDIA_TRACKS, meeting]);

  useEffect(() => {
    collectScreens();
  }, [collectScreens]);

  useEffect(() => {
    if (screensWithTracks.length > 0) fetchOsIcons(screensWithTracks);
  }, [screensWithTracks, fetchOsIcons]);

  const chooseAnotherTrack = (id) => {
    if (SCREEN_STATE.currentScreen.id !== id) {
      selectScreen(SET_SCREEN_STATE, id);
      updateFullScreenUI(true);
    }
  };

  return screensWithTracks.map((screen) => {
    // console.log(screen, JSON.stringify(screen));
    const stream = new MediaStream();
    if (!(screen?.track instanceof MediaStreamTrack)) {
      console.error("The provided object is not an instance of MediaStreamTrack.");
      return;
    }
    try {
      stream.addTrack(screen?.track);
    } catch (error) {
      console.error("Error adding track to stream:", error);
    }

    return (
      <div key={screen.id} id={`screen-${screen.name}`} className="screen" onClick={() => chooseAnotherTrack(screen.id)}>
        {/* {stream && <Video srcObject={stream} />} */}
        {stream && <Video srcObject={stream} />}
        <div className="screen-details">
          <div className="screen-information">
            <img src={osIcons[screen.id]} alt="os" className="icon-os i-32" />
            <span className="os-resolution small-font">
              {screen.res[2]}x{screen.res[3]}
            </span>
          </div>
          <div className="screen-name">
            <span> Screen {screen.id} </span>
            <span>
              {screen.name} ({screen.os})
            </span>
          </div>
        </div>
      </div>
    );
  });
});
